module.exports = __webpack_public_path__ + "img/item5-5.743844b8.png";